import { Node, mergeAttributes } from "@tiptap/core";
import Image from "@tiptap/extension-image";

export const KbImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: null,
        parseHTML: (element) => element.getAttribute("width") || element.style.width || null,
        renderHTML: (attributes) => attributes.width ? { style: `width: ${attributes.width}; max-width: 100%; height: auto;` } : {},
      },
    };
  },
}).configure({ inline: false, allowBase64: true });

export const KbCallout = Node.create({
  name: "kbCallout",
  group: "block",
  content: "block+",
  defining: true,
  addAttributes() {
    return {
      kind: {
        default: "info",
        parseHTML: (element) => element.getAttribute("data-kind") || "info",
        renderHTML: (attributes) => ({ "data-kind": attributes.kind }),
      },
    };
  },
  parseHTML() { return [{ tag: 'aside[data-kb-callout]' }]; },
  renderHTML({ HTMLAttributes }) {
    return ["aside", mergeAttributes(HTMLAttributes, { "data-kb-callout": "true", class: `kbv2-callout kbv2-callout-${HTMLAttributes["data-kind"] || "info"}` }), 0];
  },
});
